import { render, staticRenderFns } from "./CorrectionManagerList.vue?vue&type=template&id=5e768a2d"
import script from "./CorrectionManagerList.vue?vue&type=script&lang=ts"
export * from "./CorrectionManagerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports